import React from "react";
import "./Tabs.scss";
import { capitalCase } from "change-case";

class Tabs extends React.Component {
  state = {
    activeTab: this.props.activeKey
      ? this.props.activeKey
      : this.props.children[0]
      ? this.props.children[0].props.label
      : this.props.children.props.label,
  };
  changeTab = (tab) => {
    this.setState({ activeTab: tab });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.activeKey !== this.props.activeKey) {
      this.setState({ activeTab: this.props.activeKey });
    }
  }
  render() {
    let content;
    let buttons = [];
    return (
      <>
        {
          <div>
            {React.Children.map(this.props.children, (child) => {
              if (child) {
                buttons.push(child.props.label);
                if (child.props.label === this.state.activeTab)
                  content = child.props.children;
              }
            })}

            <TabButtons
              activeTab={this.state.activeTab}
              buttons={buttons}
              changeTab={
                this.props.activeKey ? this.props.changeTab : this.changeTab
              }
            />
            <div className="tab-content">{content}</div>
          </div>
        }
      </>
    );
  }
}

const TabButtons = ({ buttons, changeTab, activeTab }) => {
  return (
    <div className="tab-buttons">
      {buttons.map((button) => {
        return (
          <button
            id="button1"
            key={button}
            className={button === activeTab ? "active text-info" : ""}
            onClick={() => changeTab(button)}
          >
            {capitalCase(button)}
          </button>
        );
      })}
    </div>
  );
};

const Tab = (props) => {
  return <React.Fragment>{props.children}</React.Fragment>;
};

export default Tabs;
